const ParentLoader = () => {
    return (
        <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-watomsBlue dark:border-blue-400"></div>
        </div>
    )
};

export default ParentLoader;